/**
 * @author       matthew@zumper.com (Matthew Talamini)
 * @copyright    Copyright (c) 2021, Zumper
 * @description  Reducer for poi
 */

import type { PoiModule } from '@zcode/state-type'
import type { Values } from '@zcode/utility-types'
import { combineReducers } from 'redux'
import { type ExtractActions, handleActions } from 'redux-actions'

import type * as poiActions from '../actions'
import { RECEIVE_POI } from '../constants/index'

import { metaReducer } from './meta'

type ActionTypes = ExtractActions<Values<typeof poiActions>>

export const poiReducer = combineReducers<PoiModule, ActionTypes>({
  data: handleActions(
    {
      [RECEIVE_POI]: (state, { payload }) => {
        return payload
      },
    },
    [] as PoiModule['data']
  ),
  meta: metaReducer,
})
